import React, { useEffect, useState } from "react";
import { Button, Popconfirm, Skeleton, Table, message } from "antd";
import {
  useDeleteQuotationTemplateMutation,
  useFetchQuotationTemplatesQuery,
} from "../store/store";
import Slidebar from "../components/sidebar/Slidebar";
import { BiEdit, BiTrash } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import QuotationTemplateForm from "../components/quotationfrom/QuotationTemplateForm";
import moment from "moment";

export default function QuotationTemplate() {
  const [show, setShow] = useState(false);
  const [formdata, setFormdata] = useState();
  const [id, setId] = useState();

  const {
    data: templates,
    isLoading,
    isFetching,
  } = useFetchQuotationTemplatesQuery();

  const [deleteTemplate, deleteInfo] = useDeleteQuotationTemplateMutation();

  useEffect(() => {
    if (deleteInfo?.isSuccess) {
      message.success("Template deleted");
    }
    if (deleteInfo?.isError) {
      message.error("Delete failed");
    }
  }, [deleteInfo]);

  const createTemplate = () => {
    setFormdata(undefined);
    setId(undefined);
    setShow(true);
  };

  const editTemplate = (record) => {
    setFormdata(record);
    setId(record.id);
    setShow(true);
  };

  const deleteThisTemplate = (record) => {
    deleteTemplate(record.id);
  };

  const shows = (val) => setShow(val);

  const columns = [
    {
      title: "Sr.no",
      dataIndex: "id",
      key: "sr",
      width: 70,
      render: (text, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Special Note",
      dataIndex: "special_note",
      key: "special_note",
      width: 200,
    },
    {
      title: "Created",
      dataIndex: "created_at",
      key: "created_at",
      width: 120,
      render: (text) => (text ? moment(text).format("DD/MM/YY") : "-"),
    },
    {
      title: " ",
      key: "edit",
      fixed: "right",
      width: 50,
      render: (record) => (
        <BiEdit
          className="bi-edit"
          style={{ width: "100%", height: "20px" }}
          onClick={(e) => {
            e.stopPropagation();
            editTemplate(record);
          }}
        />
      ),
    },
    {
      title: " ",
      key: "delete",
      fixed: "right",
      width: 50,
      render: (record) => (
        <Popconfirm
          title="Sure to delete?"
          onConfirm={() => deleteThisTemplate(record)}
          onCancel={(e) => e.stopPropagation()}
        >
          <BiTrash
            className="bi-edit"
            onClick={(e) => e.stopPropagation()}
            style={{ width: "100%", height: "20px", color: "red" }}
          />
        </Popconfirm>
      ),
    },
  ];

  const TemplateFormModal = () => (
    <div className="model-con">
      <div className="model-box" style={{ width: "95vw", position: "relative", margin: "1px 0", backgroundColor: "white", padding: "20px", borderColor: "red"   }}>
        <span className="p--cross--custom" onClick={() => shows(false)}>
          <AiOutlineClose />
        </span>
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
          {id ? "Update Template" : "Create Template"}
        </h2>
        <QuotationTemplateForm datas={formdata} id={id} show={shows} />
      </div>
    </div>
  );

  return (
    <div>
      <Slidebar />
      <div className="for-etable">
        <button
          style={{
            padding: "10px 40px",
            margin: "3rem 0",
            borderRadius: "7px",
            border: "none",
            backgroundColor: "#323a3d",
            color: "white",
            fontSize: "15px",
            fontWeight: "bolder",
            cursor: "pointer",
          }}
          onClick={createTemplate}
        >
          Create New Template
        </button>
        {isLoading ? (
          <Skeleton />
        ) : (
          <Table
            className="custom-table-ant"
            columns={columns}
            loading={isFetching}
            dataSource={templates}
            rowKey="id"
            scroll={{ x: 900 }}
            size="large"
            pagination={{ pageSize: 10 }}
          />
        )}
        {show ? <TemplateFormModal /> : null}
      </div>
    </div>
  );
}
